import React, { useEffect, useState } from 'react';
import "./progressBar.css"

function ProgressBar({step, setStep, selectionsDone, infoDone, complete, error}) {
    function handleStepClick(clickedStep) {
        switch (clickedStep) {

            case 0:
                if (step < 3) {
                    setStep(0);
                }
                break;

            case 1:
                if (selectionsDone && step < 3) {
                    setStep(1);
                }
                break;

            case 2:
                if ((infoDone && selectionsDone) && step < 3) {
                    setStep(2);
                }
                break;
                
            default:
                break;
        }
    }

    return (
        <div className='progress-bar-container'>
            <div onClick={() => handleStepClick(0)} className={
                'progress-bar-step ' + 
                (step===0 ? 'current ' : '') +
                (selectionsDone ? 'complete ' : '')
                }><div className="bubble">1</div>Selections</div>
                <div className="progress-line"></div>
            <div onClick={() => handleStepClick(1)} className={
                'progress-bar-step ' + 
                (step===1 ? 'current ' : '') +
                (infoDone ? 'complete ' : '')
                }><div className="bubble">2</div>Info</div>
                <div className="progress-line"></div>
            <div onClick={() => handleStepClick(2)} className={
                'progress-bar-step ' + 
                (step===2 ? 'current ' : '') +
                (complete ? 'complete ' : '')
                }><div className="bubble">3</div>Payment</div>
                <div className="progress-line"></div>
            <div className={
                'progress-bar-step ' + 
                (step===3 ? 'current ' : '') +
                (complete ? 'complete ' : '')
                }><div className="bubble">4</div>Complete</div>
        </div>
    );
};

export default ProgressBar;
